export const VEHICLE_INFORMATIONS_STRINGS = {
	VEHICLE_PHOTO_ALT: 'Veiculo foto',
	KM_UNIT: 'Km',
	SEE_AD: 'Ver anúncio',
} as const;
